import { TextField, InputAdornment } from "@mui/material";
import React, { forwardRef } from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  hideArrows: {
    "& input[type='number']::-webkit-inner-spin-button, input[type='number']::-webkit-outer-spin-button":
      {
        "-webkit-appearance": "none",
        margin: 0,
      },
    "& input[type='number']": {
      "-moz-appearance": "textfield",
    },
  },
});

const Input = forwardRef((props, ref) => {
  const classes = useStyles();

  return (
    <TextField
      variant="outlined"
      margin="dense"
      inputRef={ref}
      fullWidth
      size="small"
      className={classes.hideArrows}
      InputProps={{
        ...(props.symbol && {
          startAdornment: (
            <InputAdornment position="start">{props.symbol}</InputAdornment>
          ),
        }),
      }}
      {...props}
    />
  );
});

// const Input = ({ name, label, control, helperText, ...props }) => {
//   <Controller
//     control={control}
//     name={name}
//     defaultValue={props.value || false}
//     render={({ field: { onChange, value } }) => (
//       <TextField
//         variant="outlined"
//         margin="dense"
//         fullWidth
//         onChange={onChange}
//         value={value}
//         size="small"
//         {...props}
//       />
//     )}
//   />;
// };

export default Input;
